import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const card = css`
  position: relative;
  border-radius: 8px;
  border: solid 1px ${withVar(DesignToken.BorderBasicPrimary)};
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};

  margin-top: 20px;
  &:first-child {
    margin-top: 0;
  }
`;

export const cardTitle = css`
  padding: 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

export const cardHead = css`
  padding: 19px 20px;
`;

export const cardBody = css`
  position: relative;
`;
